// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { findLocationModalStyles } from "@synd/Overrides/Components/FindLocationModal";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { css } from "styled-components";

findLocationModalStyles.searchGridContainer = {
    gap: 12,
};

findLocationModalStyles.selectedWarehouseAddressDisplay = {
    wrapper: {
        css: css`
            font-style: normal;
            font-size: ${fontConfig.small.size}px;
            line-height: ${fontConfig.small.lineHeight};
        `,
    },
};
